// extracted by css-extract-rspack-plugin
export default {"sectionContainer":"bFxNf","listContainer":"yk7pm"};